export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/c5d6534f4f2cb925009575e748220704.svg";